// Subcards have no persistent id, so they are identified by a hash of their
// content (question + answer). The same function must run on client and server
// so the keys match. FNV-1a 32-bit over the normalized text; deterministic and
// dependency-free.
export function subcardKey(question: string, answer: string): string {
    const normalized = question.trim() + ' ' + answer.trim();

    let hash = 0x811c9dc5;
    for (let i = 0; i < normalized.length; i++) {
        hash ^= normalized.charCodeAt(i);
        hash = Math.imul(hash, 0x01000193);
    }

    return (hash >>> 0).toString(16).padStart(8, '0');
}
